"use strict";
var Observable_1 = require('../../Observable');
var from_1 = require('../../observable/from');
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/from.js
 ** module id = 81
 ** module chunks = 2
 **/